export default (values) => {
  const errors = {}
  if (values.password && values.currentPassword === values.password) {
    errors.password = 'New password must be different from current password.';
  }
  if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Passwords do not match.';
  }
  return errors;
}